import {
  SEND_BATCH_MAIL,
  BATCH_MAIL_LIST,

  EMAIL_BATCH_SUCCESS,
  EMAIL_BATCH_ERROR,

} from "./actionTypes"

// Send mail Batch
export const sendMailBatch = (data, history, callback) => {
  return {
    type: SEND_BATCH_MAIL,
    payload: { data, history, callback }
  }
}

// list mail
export const listMailBatch = (data, callback) => {
  return {
    type: BATCH_MAIL_LIST,
    payload: { data, callback },
  }
}

export const mailBatchSuccess = message => {
  return {
    type: EMAIL_BATCH_SUCCESS,
    payload: message,
  }
}

export const mailBatchError = message => {
  return {
    type: EMAIL_BATCH_ERROR,
    payload: message,
  }
}
